import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM2} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {
  GesamtesUnternehmenM2,
  NachCodierungM1,
  NachFunktionM1,
  NachFunktionM2
} from 'shared/dtos/cockpit-kontrolle/weitere-funktionenstatistiken';
import {FunctionRating} from 'shared/dtos/function-rating';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';

import {Component, ElementRef, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-chart-dialog-weitere-funktionenstatistiken',
  templateUrl: './chart-dialog-weitere-funktionenstatistiken.component.html',
  styleUrl: './chart-dialog-weitere-funktionenstatistiken.component.scss',
  standalone: false
})
export class ChartDialogWeitereFunktionenstatistikenComponent
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;

  isForM2 = false;
  gesamtesUnternehmen: GesamtesUnternehmenM2;
  nachFunktion: NachFunktionM1[] | NachFunktionM2[];
  nachCodierung: NachCodierungM1[];
  funktionen: FunctionRating[];
  constructor(
    protected readonly translate: TranslateService,
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService,
    private readonly element: ElementRef
  ) {
    super(translate);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initializeData();
  }

  exportTable1() {
    const cardTitle = this.translate.instant(
      'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.title'
    );
    this.tableExport.exportHtmlTable('wfunkstat.fn', cardTitle);
  }

  exportTable2() {
    const cardTitle = this.translate.instant(
      'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.title'
    );
    this.tableExport.exportHtmlTable('wfunkstat.bst-anf', cardTitle);
  }

  private async initializeData() {
    this.isForM2 = await this.storage.getIsForModule2();
    this.funktionen = await this.storage.getFunktionen();
    const weiterFncStatistiken = (
      (await this.storage.getCockpitKontrolle()) as CockpitKontrolleM2
    )?.weitereFunktionenstatistiken;
    this.nachFunktion = weiterFncStatistiken?.nachFunktion;
    this.nachCodierung = weiterFncStatistiken?.nachCodierung;
    this.gesamtesUnternehmen = weiterFncStatistiken.gesamtesUnternehmen;
  }
}
